import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Accordion, Card, Image } from 'react-bootstrap';
import { useState } from 'react';
import './PolicyDetails.css';
import { DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showCallMeModal, showComingSoon } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import FAQItem from '../../FAQ/FAQItem';
import { Link } from 'react-router-dom';
import { SA_COUNTRY_ID_NUMBER } from '../../../constants/internationalization';

const PolicyDetailsWarranty = () => {

    const profileState = useSelector(state => state.profile);
    const cover = useSelector(state => state.profile.selectedPersonalCover);
    const dispatch = useDispatch();
    const [reminderDismissed, updateReminderDismissed] = useState(false);
    const [accordionActiveKey, setAccordionActiveKey] = useState(-1);
    const isMobile = window.innerWidth <= 975;

    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]

    function addWarranty() {
        dispatch(showCallMeModal(true));
    }

    function dismissMissingInfoReminder() {
        updateReminderDismissed(true);
    }

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    function submitAClaim() {
        dispatch(showComingSoon());
    }

    let coveredBenefits = <div></div>;
    let nonCoveredBenefits = <div></div>;

    if (cover !== undefined) {
        coveredBenefits = cover.riskItems[0].warrantyDetails.warrantyBenefits.filter(x => x.description !== "No Cover").map((item) => {
            return '<div key= ' + item.benefitName + ' id= ' + item.benefitName + ' class="">' +
                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">' + item.benefitName + '</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + item.description + '</p>' +
                '</div>' +
                '</div>'
        }).join("");

        nonCoveredBenefits = cover.riskItems[0].warrantyDetails.warrantyBenefits.filter(x => x.description === "No Cover").map((item) => {
            return '<div key= ' + item.benefitName + ' id= ' + item.benefitName + ' class="">' +
                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">' + item.benefitName + '</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + item.description + '</p>' +

                '</div>' +
                '</div>'
        }).join("");
    }

    let country = (profileState.countryId === SA_COUNTRY_ID_NUMBER) ? "SA" : "Namibia";

    let faqSet = [{
        header: "Benefits",
        body: '' + coveredBenefits + '' + nonCoveredBenefits + '',

        id: 1
    },
    {
        header: "Car Details",
        body: '<div class="form-group"><div class="form-group row noma">' +
            '<p class="col-7 col-form-label"> Registered in ' + country + '</p>' +
            '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].vehicleDetails.vehicleRegisteredLocally + '</p>' +
            '</div>' +
            '<div class="form-group row noma">' +
            '<p class="col-7 col-form-label">Performance modification</p>' +
            '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].vehicleDetails.vehicleModified + '</p>' +
            '</div>' +
            '<div class="form-group row noma">' +
            '<p class="col-7 col-form-label">Full service history</p>' +
            '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].vehicleDetails.fullServiceHistory + '</p>' +
            '</div>' +
            '<div class="form-group row noma">' +
            '<p class="col-7 col-form-label">Approximate kilometers</p>' +
            '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].vehicleDetails.approximateKilometers + ' km</p>' +
            '</div>',

        id: 2
    },];

    let faq;
    if (faqSet) {
        faq = faqSet.map((item) => {
            if (item.header !== "") {
                return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={accordionActiveKey} />
            }
        });
    }

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Car Warranty" />
            }

            <div className="d-lg-block d-none" id="PolicyDetails">
                {!reminderDismissed && cover && (cover.riskItems[0].vehicleDetails.engineNumber === null || cover.riskItems[0].vehicleDetails.engineNumber === undefined) && (cover.riskItems[0].vehicleDetails.vinNumber === null || cover.riskItems[0].vehicleDetails.vinNumber === undefined) && (cover.riskItems[0].vehicleDetails.registrationNumber === null || cover.riskItems[0].vehicleDetails.registrationNumber === undefined) &&
                    <div className="Reminder-banner banner-padding">
                        <div className="cursor-pointer row noma" onClick={editPolicyInfo}>
                            <div className="nopa mr-15px">
                                <img src="Images/White.svg" className="warning-icon-car" />
                            </div>
                            <div className="col-10 nopa">
                                <p className="Monthly-mileage-update-car mb-0px">We're missing some info about your car. Tap <Link onClick={editPolicyInfo} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">here</Link> to resolve this now. </p>
                            </div>
                        </div>
                        <div onClick={dismissMissingInfoReminder}>
                            <Image className="Reminder-banner-close-img-car" src="./images/icons-navigation-close-16-px-white.svg" alt="Dismiss" />
                        </div>
                    </div>
                }
                <div className="box">
                    <div className="pl-3 pr-3 pb-3">
                        <div id="firstDiv" className="">
                            <div className="row mb-3 pt-3">
                                <div className="col-7">
                                    <h2 className="carName mb-0">Car warranty</h2>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-7">
                                    <h5 className="mb-0"><b>{cover.riskItems[0].description}</b></h5>
                                    <p className="mb-0">Comprehensive cover on <b>agreed value</b></p>
                                </div>
                                <div className="col-lg-5 text-right mt-lg-2">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol} {cover.riskItems[0].premium} pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div>
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                            </div>

                            <hr className="line-devider" />
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h5 className="mb-2"><b>Excess amount</b></h5>
                                        <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : profileState.countryId === 244 ? cover.riskItems[0].excessDescription : cover.riskItems[0].excessDescription.replace(/R /g, profileState.currencySymbol + " ")}</p>                                       
                                        {cover.riskItems[0].vehicleDetails.insuredForValue &&
                                        <p className="mb-0">Insured for {profileState.currencySymbol} {cover.riskItems[0].vehicleDetails.insuredForValue}</p>}
                                    </div>
                            </div>

                            <hr className="line-devider" />
                            <div className="">
                                <h5 className="mb-2"><b>Waiting period</b></h5>
                            </div>
                            <div className="row mb-lg-0">
                                <div className="col-7">
                                    <p className="mb-2">The first 30 days of cover (and pre-existing damage)</p>
                                </div>
                                <div className="col-5 text-right">
                                    <p className="mb-0"><b>There's no cover</b></p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <p className="mb-2">The first 30 to 60 days of cover</p>
                                </div>
                                <div className="col-6 text-right ml-0px pl-0px">
                                    <p className="mb-0"><b>You're covered for up to 25% of the cost of the repair or sum insured (whichever is less)</b></p>
                                </div>
                                <hr className="policy-details-hr mt-14px mb-15px" />
                            </div>

                            <hr className="line-devider" />
                            <div className="accordion-holder">
                                <Accordion onSelect={(e) => setAccordionActiveKey(Number(e))}>
                                    {faq}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="d-lg-none d-block mb-5" id="PolicyDetailsMobile" style={{ display: "none" }}>
                {!reminderDismissed && cover && (cover.riskItems[0].vehicleDetails.engineNumber === null || cover.riskItems[0].vehicleDetails.engineNumber === undefined) && (cover.riskItems[0].vehicleDetails.vinNumber === null || cover.riskItems[0].vehicleDetails.vinNumber === undefined) && (cover.riskItems[0].vehicleDetails.registrationNumber === null || cover.riskItems[0].vehicleDetails.registrationNumber === undefined) &&
                    <div className="Reminder-banner banner-padding">
                        <div className="cursor-pointer row noma" onClick={editPolicyInfo}>
                            <div className="nopa mr-15px">
                                <img src="Images/White.svg" className="warning-icon-car" />
                            </div>
                            <div className="col-10 nopa">
                                <p className="Monthly-mileage-update-car mb-0px">We're missing some info about your car. Tap <Link onClick={editPolicyInfo} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">here</Link> to resolve this now. </p>
                            </div>
                        </div>
                        <div onClick={dismissMissingInfoReminder}>
                            <Image className="Reminder-banner-close-img-car" src="./images/icons-navigation-close-16-px-white.svg" alt="Dismiss" />
                        </div>
                    </div>
                }
                <div className="box pl-3 pr-3 pb-3 pt-3">
                    <div className="row">
                        <div className="col-12 mb-lg-0">
                            <h2 className="carName mb-0">Car warranty</h2>
                        </div>
                        <div className="col-12 mb-lg-0 pb-2">
                            <h5 className="mb-0"><b>{cover.riskItems[0].description}</b></h5>
                        </div>
                        <div className="col-12 mb-4">
                            <h3 className="coverAmount mb-3">{profileState.currencySymbol} {cover.riskItems[0].premium}pm</h3>
                            {coverStartDate.length > 0 &&
                                <div>
                                    <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                    <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                </div>
                            }
                        </div>
                        <div className="col-12 mb-3">
                            <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                        </div>
                    </div>

                    <hr className="line-devider" />
                    <div className="row pt-3">
                        <div className="col-12">
                            <h5 className="mb-2"><b>Excess amount</b></h5>
                            <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : profileState.countryId === 244 ? cover.riskItems[0].excessDescription : cover.riskItems[0].excessDescription.replace(/R /g, profileState.currencySymbol + " ")}</p>
                            {cover.riskItems[0].vehicleDetails.insuredForValue &&
                                <p className="mb-0">{profileState.currencySymbol} {cover.riskItems[0].vehicleDetails.insuredForValue}</p>}
                        </div>
                    </div>

                    <hr className="line-devider" />
                    <div className="mb-3">
                        <div className="pt-3">
                            <h5 className="mb-2"><b>Waiting period</b></h5>
                        </div>
                        <div>
                            <p className="mb-0">The first 30 days of cover (and pre-existing damage)</p>
                        </div>
                        <div>
                            <p className="mb-3"><b>There's no cover</b></p>
                        </div>
                        <div>
                            <p className="mb-0">The first 30 to 60 days of cover</p>
                        </div>
                        <div>
                            <p className="mb-3"><b>You're covered for up to 25% of the cost of the repair or sum insured (whichever is less)</b></p>
                        </div>
                    </div>

                    <hr className="line-devider" />
                    <div className="accordion-holder">
                        <Accordion onSelect={(e) => setAccordionActiveKey(Number(e))}>
                            {faq}
                        </Accordion>
                    </div>
                </div>                
            </div>
            <div>
                <Card className="mt-3 mb-5 cursor-pointer">
                    <Card.Body>
                        <div className="row noma" onClick={addWarranty}>
                            <div className="nopa mr-20px">
                                <img src=".\Images\OnlineQuotes\icon-addcover-car-warranty-insurance.svg" title="Get car insurance for another vehicle" alt="car insurance" className="add-cover-image" />
                            </div>
                            <div className="col-lg col-9 nopa">
                                <div className="row noma">
                                    <div className="col-11 px-0 mt-3 nopa">
                                        <p className="mb-0"><b>Get car warranty for another car</b></p>
                                    </div>
                                    <div className="col-lg col-1 mt-2 pl-0 pl-lg-2 nopa" style={{ paddingTop: "2px" }}>
                                        <Image src="./Images/TopNav/add-cover-nugreen-46px-46px.svg" className="mx-auto d-block cursor-pointer" onClick={addWarranty} style={{ height: "30px" }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    )
}

export default (PolicyDetailsWarranty);